module.exports = __webpack_public_path__ + "static/media/persona.47744e4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/persona.png
// module id = 616
// module chunks = 0